import get from 'lodash/get';
import omit from 'lodash/omit';
import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'paperwork.paperworkAppointmentDetails');

export const selectPaperworkAppointmentData = createSelector(
  selectRootState,
  state => omit(state, 'sending', 'error', 'succeed', 'rejected'),
);

export const selectPaperworkAppointmentDataPending = createSelector(
  selectRootState,
  state => get(state, 'sending', false),
);

export const selectPaperworkAppointmentDataSucceed = createSelector(
  selectRootState,
  state => get(state, 'succeed'),
);

export const selectPaperworkAppointmentDataError = createSelector(
  selectRootState,
  state => get(state, 'error'),
);

export const selectPaperworkAppointmentId = createSelector(
  selectRootState,
  state => get(state, 'id', null),
);

export const selectPaperworkAppointmentVisitTypeCode = createSelector(
  selectRootState,
  state => get(state, 'visitType.code'),
);

export const selectPaperworkAppointmentUserId = createSelector(
  selectRootState,
  state => get(state, 'userId', null),
);

export const selectPaperworkAppointmentIsAllConsentsSigned = createSelector(
  selectRootState,
  state => get(state, 'consentsAssignment.allSigned', false),
);

export const selectPaperworkAppointmentConsents = createSelector(
  selectRootState,
  state => get(state, 'consentsAssignment.consents', []),
);

export const selectPaperworkAppointmentConsentsCount = createSelector(
  selectRootState,
  state => get(state, 'consentsAssignment.consentsCount', 0),
);

export const selectPaperworkAppointmentOrgId = createSelector(
  selectRootState,
  state => get(state, 'organization.id', null),
);

export const selectPaperworkAppointmentServiceId = createSelector(
  selectRootState,
  state => get(state, 'service.id', null),
);

export const selectPaperworkAppointmentQuestionAnswers = createSelector(
  selectRootState,
  state => get(state, 'questionAnswers', null),
);

export const selectPaperworkAppointmentPcpData = createSelector(
  selectRootState,
  state => {
    const {
      pcpProviderAnswer,
      pcpName,
      considerUsPcp,
      primaryCareProvider,
    } = state;
    return { pcpProviderAnswer, pcpName, considerUsPcp, primaryCareProvider };
  },
);

export const selectPaperworkAppointmentPaperworkCompleted = createSelector(
  selectRootState,
  state => get(state, 'paperworkCompleted', false),
);

const selectPaperworkAppointmentOrganization = createSelector(
  selectRootState,
  state => get(state, 'organization', {}),
);

export const selectPaperworkAppointmentTenantSkipInsurance = createSelector(
  selectPaperworkAppointmentOrganization,
  state => get(state, 'tenant.skipInsurance', false),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/paperwork-get-appointment-details.js